import { render, staticRenderFns } from "./9.vue?vue&type=template&id=d4647fec&scoped=true&"
import script from "./9.vue?vue&type=script&lang=js&"
export * from "./9.vue?vue&type=script&lang=js&"
import style0 from "./9.vue?vue&type=style&index=0&id=d4647fec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4647fec",
  null
  
)

export default component.exports